module.exports = __webpack_public_path__ + "static/media/falmouth-4.93f028ef.jpg";